"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractModelLight = void 0;
var lodash_1 = require("lodash");
/**
 * Similar to Abstract Model, but not tied to a table
 */
var AbstractModelLight = /** @class */ (function () {
    function AbstractModelLight(properties) {
        this.properties = properties;
    }
    Object.defineProperty(AbstractModelLight.prototype, "props", {
        get: function () {
            return this.properties;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @alias get props
     */
    AbstractModelLight.prototype.get = function () {
        return this.props;
    };
    AbstractModelLight.prototype.set = function (props) {
        this.properties = lodash_1.extend(this.properties, props);
    };
    return AbstractModelLight;
}());
exports.AbstractModelLight = AbstractModelLight;
